var acc = document.getElementsByClassName("accordionsize");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panelsize = this.nextElementSibling;
    if (panelsize.style.maxHeight) {
      panelsize.style.maxHeight = null;
    } else {
      panelsize.style.maxHeight = panelsize.scrollHeight + "px";
    }
  });
}
